import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import rem from 'polished/lib/helpers/rem';

import spacing from '@decisiv/design-tokens/lib/spacing';
import color from '@decisiv/design-tokens/lib/color';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import Table from '@decisiv/ui-components/lib/components/Table';

export const OverflowTable = styled(Table)`
  overflow: auto;

  && {
    table thead th div {
      white-space: nowrap;
    }
  }
` as typeof Table;

export const Container = styled(Flex)`
  flex-direction: column;
  flex: 1;
  background-color: ${toColorString(color.base.fullMoon)};

  overflow: hidden;
`;

export const Filters = styled(Flex).attrs({ paddingY: 1, paddingX: 2 })`
  align-items: center;
  gap: ${rem(spacing.base)};

  border-bottom: 1px solid ${toColorString(color.base.quarterMoon)};
`;

export const Header = styled(Flex).attrs({ paddingY: 0.5, paddingX: 2 })`
  align-items: center;
  gap: ${rem(spacing.base)};

  border-bottom: 1px solid ${toColorString(color.base.quarterMoon)};
`;

export const ActivityList = styled(Flex).attrs({
  paddingX: 2,
  paddingTop: 2,
  marginBottom: 2,
})`
  flex-direction: column;
  flex: 1;
  gap: ${rem(spacing.base)};
  overflow: auto;
`;
